<template>
  <div class="layout">
    <!-- 主要内容区域 -->
    <main class="main-content">
      <slot></slot>
    </main>
  </div>
</template>

<script>
export default {
  name: "MainLayout",
  mounted() {
    this.$bus.on("on-error", (message) => {
      this.$alert(message);
    });

    this.$bus.on("need-yiban-login", ({ forgetUrl, loginUrl, regUrl }) => {
      this.$confirm({
        message: `<div><p>易班新用户请点击注册，老用户请登录原有易班网账号。</p><p>如您已有易班账号，但忘记密码，请点击“<a href="${forgetUrl}">找回密码</a>”</p></div>`,
        raw: true,
        acceptText: "登录",
        cancelText: "注册",
      }).then((result) => {
        location.href = result ? loginUrl : regUrl;
      });
    });
  },
};
</script>

<style>
.layout {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>